<template>
  <validation-provider :rules="rules" :name="`${tab}.${field}`" v-slot="{ valid, errors, changed }" :class="className">
    <b-input-group :append="appendText">
      <b-form-input
        :type="type"
        :value="getField"
        @input="updateField"
        :state="onValidateField(valid, errors, changed)"
        :placeholder="placeholder"
        :label="field"
      ></b-form-input>
      <b-form-invalid-feedback class="invalid-feedback">{{ errors[0] }}</b-form-invalid-feedback>
    </b-input-group>
  </validation-provider>
</template>

<script>
  import { ValidationProvider } from 'vee-validate'
  import { mapState } from 'vuex'
  import { validateField } from '@/helpers/formHelper.js'

  export default {
    components: {
      ValidationProvider
    },
    props: {
      tab: {
        type: String,
        required: true
      },
      field: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      placeholder: String,
      className: String,
      rules: String,
      appendText: String
    },
    computed: mapState({
      getField (state) {
        const { tab, field } = this
        return state.calculator.formData[tab][field]
      }
    }),
    methods: {
      getFormat () {
        if (this.format) {
          const format = this.format.split('.')[1].replace(/.$/, 1)
          const concatedFormat = '.'.concat(format)
          return concatedFormat
        }
      },
      updateField (value) {
        const { tab, field } = this
        this.$store.commit('calculator/SET_FORMFIELD_VALUE', {
          tab,
          field,
          value
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .invalid-feedback{
    order: 3;
  }
</style>
